import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: At Abbey's side
 * id 0ED785A3-7387-4989-BF3A-11F2F53C81B5
 * name pin-off-outline
 * version: 2.3.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pin-off-outline.svg
 * tags
 */
export const PinOffOutlineIcon = createSvgIcon(<><path d="M8,6.2V4H7V2H17V4H16V12L18,14V16H17.8L14,12.2V4H10V8.2L8,6.2M20,20.7L18.7,22L12.8,16.1V22H11.2V16H6V14L8,12V11.3L2,5.3L3.3,4L20,20.7M8.8,14H10.6L9.7,13.1L8.8,14Z" /></>, 'PinOffOutlineIcon');
export default PinOffOutlineIcon